// A font's src is written into the stylesheet as given, so it may hold only
// the functions a src descriptor takes, and no character that could close the
// string, the declaration, the @font-face block or the style element.
const space = String.raw`[ \t]*`;
// Inside a closed string a semicolon or brace is inert, and the BFF does not
// percent-encode them in a URL's query, so a string keeps out only its own
// quote, a lone backslash, a line break and the '<' of a closing style tag.
// Control characters are kept out of the whole value by isControlCharacter.
const quoted = String.raw`"(?:[^"\\\r\n<]|\\\\)*"|'(?:[^'\\\r\n<]|\\\\)*'`;
const identifier = String.raw`[\w-]+`;

const call = (name: string, argument: string) =>
  String.raw`${name}\(${space}(?:${argument})${space}\)`;

const token = [
  call('url', String.raw`${quoted}|[^\s"'()\\<;{}]+`),
  call('local', String.raw`${quoted}|${identifier}(?:[ \t]+${identifier})*`),
  call('format', String.raw`${quoted}|${identifier}`),
  call('tech', String.raw`${identifier}(?:${space},${space}${identifier})*`),
].join('|');

const separator = String.raw`${space},${space}|[ \t]+`;

const fontSrcPattern = new RegExp(
  String.raw`^(?:${token})(?:(?:${separator})(?:${token}))*$`,
  'i',
);

// Far beyond any real src, signed asset URLs included; it only bounds what a
// runaway value costs the pattern.
const maxFontSrcLength = 4096;

// CSS preprocessing turns a form feed into a newline, which ends a string
// early, and no real src holds any control character, so none but tab, which
// the grammar reads as whitespace, gets in anywhere.
const isControlCharacter = (character: string): boolean => {
  const code = character.charCodeAt(0);
  return (code < 0x20 && code !== 0x09) || code === 0x7f;
};

export const isSafeFontSrc = (src: string): boolean =>
  src.length <= maxFontSrcLength &&
  !Array.from(src).some(isControlCharacter) &&
  fontSrcPattern.test(src);
